
let icon = {
    success:
    '<span class="material-symbols-outlined">task_alt</span>',
    danger:
    '<span class="material-symbols-outlined">error</span>',
    warning:
    '<span class="material-symbols-outlined">warning</span>',
    info:
    '<span class="material-symbols-outlined">info</span>',
};

export const showToast = (message = "Sample Message", toastType = "info", duration = 5000, removeOld = false) => {
    if (!Object.keys(icon).includes(toastType)) {
        toastType = "info";
    }

    let container = document.getElementById("toast-container");

    let box = document.createElement("div");
    box.classList.add("toast", `toast-${toastType}`, `slide-in`);
    box.innerHTML = 
        `<div class="toast-content-wrapper">
        <div class="toast-icon">
        ${icon[toastType]}
        </div>
        <div class="toast-message">${message}</div>
        <div class="toast-progress"></div>
        </div>`;
    
    console.log(`Duration: ${duration}`);

    duration = duration || 5000;
    box.querySelector(".toast-progress").style.animationDuration = `${duration / 1000}s`;

    if (removeOld) {
        let toastAlready = document.body.querySelector(".toast");
        if (toastAlready) {
            toastAlready.remove();
        }
    }

    container.insertBefore(box, container.firstChild);

    // Remove after the duration of the animation
    setTimeout(() => {
        box?.remove();
    }, duration)
};